import React from 'react';
import VoxelButton, { VoxelButtonProps } from '../Buttons/VoxelButton';

export interface VoxelDialogActionCancelProps extends Omit<VoxelButtonProps, 'title'> {
  title?: string;
}

export const VoxelDialogActionCancel: React.FC<VoxelDialogActionCancelProps> = ({
  title = 'Cancel',
  ...props
}) => {
  return (
    <VoxelButton
      shape="square"
      color="transparent"
      size="lg"
      type="button"
      title={title}
      {...props}
    />
  );
};

export default VoxelDialogActionCancel;
